module.exports = __webpack_public_path__ + "img/panda_org_icon.88552a0a.svg";